import React from "react";
import "./ProfileCard.scss";
import ResetPasswordConfirmationModal from "../ResetPasswordConfirmationModal/ResetPasswordConfirmationModal";
import ResetPasswordModal from "../ResetPasswordModal/ResetPasswordModal";
import ProfilePicUpload from "../ProfilePicUpload/ProfilePicUpload";
import editIcon from "../../../assets/icons/edit.svg";
import { gql } from "@apollo/client";
import { uploadClient } from "../../../index";
import { notify } from "../../Notify/Notify";

export default class ProfileCard extends React.Component {
  state = {
    firstName: this.props.firstName,
    lastName: this.props.lastName,
    mobileNo: this.props.mobileNo,
    showResetPasswordConfirmationModal: false,
    showResetPasswordModal: false,
    isFormEditable: false,
    isClicked: false,
    isProfilePicChanged: false,
  };

  mobileNoRef = React.createRef();

  hasValidValues = () => {
    return (
      this.state.firstName.trim().length > 0 &&
      this.state.lastName.trim().length > 0 &&
      !this.state.isClicked
    );
  };

  onEnterPressed = (e, target) => {
    if (e.key === "Enter") {
      if (target === "mobileNo") {
        this.mobileNoRef.current.blur();
      }
    }
  };

  saveProfileDataHandler = (e) => {
    this.setState({
      isClicked: true,
    });
    e.preventDefault();
    let firstName = this.state.firstName.trim();
    let lastName = this.state.lastName.trim();
    let mobileNo = this.state.mobileNo;
    let image = null;
    if (this.state.isProfilePicChanged) {
      image = this.props.profilePic;
    }

    const dataURItoBlob = (dataURI) => {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);
      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    };

    const UPDATE_PROFILE = gql`
      mutation profileUpdate(
        $firstName: String!
        $lastName: String!
        $mobileNumber: String!
      ) {
        profileUpdate(
          firstName: $firstName
          lastName: $lastName
          mobileNumber: $mobileNumber
        ) {
          success
        }
      }
    `;

    const UPDATE_PROFILE_WITH_PHOTO = gql`
      mutation profileUpdate(
        $image: Upload!
        $firstName: String!
        $lastName: String!
        $mobileNumber: String!
      ) {
        profileUpdate(
          profileImage: $image
          firstName: $firstName
          lastName: $lastName
          mobileNumber: $mobileNumber
        ) {
          success
        }
      }
    `;

    const variables = {
      firstName: firstName,
      lastName: lastName,
      mobileNumber: mobileNo,
    };

    if (image) {
      variables["image"] = dataURItoBlob(image);
    }

    uploadClient
      .mutate({
        mutation: image ? UPDATE_PROFILE_WITH_PHOTO : UPDATE_PROFILE,
        variables: variables,
      })
      .then((result) => {
        this.props.changeNameAndMobileNoHandler({
          firstName: firstName,
          lastName: lastName,
          mobileNo: mobileNo,
        });
        this.setState({
          isFormEditable: false,
          isProfilePicChanged: false,
        });
        notify("Success", "Profile data updated successfully.", "success");
        if (image && this.props.location.state.loadProfileImage) {
          this.props.location.state.loadProfileImage();
        }
      })
      .catch((e) => {
        notify("Error", e.message, "error");
      });
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        firstName: this.props.firstName,
        lastName: this.props.lastName,
        mobileNo: this.props.mobileNo,
      });
    }
  }

  render() {
    return (
      <div className="user-profile-card">
        <div className="d-flex justify-content-between">
          <ProfilePicUpload
            profilePic={this.props.profilePic}
            setProfilePicHandler={(img) => {
              this.setState({
                isFormEditable: true,
                isProfilePicChanged: true,
                isClicked: false,
              });
              this.props.setProfilePicHandler(img);
            }}
          />

          {!this.state.isFormEditable ? (
            <img
              src={editIcon}
              alt="Edit"
              width="24"
              height="24"
              className="edit-icon"
              onClick={() => {
                this.setState({ isFormEditable: true, isClicked: false });
              }}
            />
          ) : null}
        </div>

        <form>
          <div
            className={[
              "form-groups profile-fields",
              !this.state.isFormEditable ? "not-editable" : "",
            ].join(" ")}
          >
            <div className="form-group">
              <label>First Name</label>
              <input
                type="text"
                maxLength="15"
                value={this.state.firstName}
                onChange={(e) => this.setState({ firstName: e.target.value })}
                onKeyPress={(e) => this.onEnterPressed(e, "firstName")}
                className="form-control name"
                placeholder="-"
              />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input
                type="text"
                maxLength="15"
                value={this.state.lastName}
                onChange={(e) => this.setState({ lastName: e.target.value })}
                onKeyPress={(e) => this.onEnterPressed(e, "lastName")}
                className="form-control name"
                placeholder="-"
              />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                maxLength="50"
                value={this.props.email}
                className="form-control email"
                placeholder="Email address"
                disabled
              />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="text"
                value={this.state.mobileNo}
                maxLength="10"
                onChange={(e) => {
                  const re = /^[0-9\b]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) {
                    this.setState({ mobileNo: e.target.value });
                  }
                }}
                onKeyPress={(e) => this.onEnterPressed(e, "mobileNo")}
                ref={this.mobileNoRef}
                className="form-control mobile-number"
                placeholder="-"
              />
            </div>
            {this.state.isFormEditable ? (
              <button
                className="btn-primary save-button"
                disabled={!this.hasValidValues()}
                onClick={this.saveProfileDataHandler}
                type="submit"
              >
                Save
              </button>
            ) : null}
          </div>
        </form>

        <p
          className="reset-password"
          onClick={() =>
            this.setState({ showResetPasswordConfirmationModal: true })
          }
        >
          Reset Password
        </p>

        <ResetPasswordConfirmationModal
          showModal={this.state.showResetPasswordConfirmationModal}
          handleClose={() =>
            this.setState({ showResetPasswordConfirmationModal: false })
          }
          openResetPasswordModal={() =>
            this.setState({
              showResetPasswordModal: true,
              showResetPasswordConfirmationModal: false,
            })
          }
        />

        <ResetPasswordModal
          showModal={this.state.showResetPasswordModal}
          email={this.props.email}
          handleClose={() => this.setState({ showResetPasswordModal: false })}
        />
      </div>
    );
  }
}
